import { render, staticRenderFns } from "./main-visual.vue?vue&type=template&id=8be390ec&scoped=true&"
import script from "./main-visual.vue?vue&type=script&lang=js&"
export * from "./main-visual.vue?vue&type=script&lang=js&"
import style0 from "./main-visual.vue?vue&type=style&index=0&id=8be390ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be390ec",
  null
  
)

export default component.exports